import StatusTag from './status-tag'

export default StatusTag
